<template>
  <div id="app">
    <template v-if="isLoading">
      <GIF/>
    </template>
    <template v-else>
      <template v-if="showForms">
        <Forms />
      </template>
      <template v-else>
        <Login />
      </template>
    </template>
  </div>
</template>

<script>
import Forms from "./views/FormsView.vue";
import Login from "./views/Login.vue";

import GIF from "./views/GIF.vue"

import { auth } from "./Database/firebase.js";


export default {
  name: "App",

  components: {
    Forms,
    Login,
    GIF
  },
  data: () => {
    return {
      showForms: null,
      isLoading: true,
    };
  },

  async created() {
    await auth.onAuthStateChanged(async (user) => {
      if (user) {
        this.showForms = true;
      } else {
        this.showForms = false;
      }
      this.isLoading=false;
    });
  },
  methods: {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 5%;
}
</style>
